import { useEffect, useState } from "react"
import { CircleDot } from "lucide-react"
import {
  getCachedLucideIcon,
  loadLucideIcon,
  type IconComponent,
} from "./lucideBulletIconCache"

export function LucideBulletIcon({
  name,
  className,
  strokeWidth = 2.5,
}: {
  name: string
  className?: string
  strokeWidth?: number
}) {
  const [iconName, setIconName] = useState(name)
  const [Icon, setIcon] = useState<IconComponent | null>(
    () => getCachedLucideIcon(name) ?? null,
  )

  if (name !== iconName) {
    setIconName(name)
    // Function form: Icon components are callables; bare setIcon(Comp) is an updater.
    setIcon(() => getCachedLucideIcon(name) ?? null)
  }

  useEffect(() => {
    let cancelled = false
    loadLucideIcon(name)
      .then((loaded) => {
        if (!cancelled) setIcon(() => loaded)
      })
      .catch((error) => {
        console.error(error)
        if (!cancelled) setIcon(() => null)
      })
    return () => {
      cancelled = true
    }
  }, [name])

  const iconProps = {
    className,
    strokeWidth,
    "aria-hidden": true as const,
    "data-testid": `icon-${Icon ? name : "circle-dot"}`,
  }
  return Icon ? <Icon {...iconProps} /> : <CircleDot {...iconProps} />
}
